/**
 * האם פריט תפריט תצוגת צ'אט (ברירת מחדל או מותאם) מוצג למשתמש המחובר
 */
export function isSidebarChatViewVisibleForUser(
  viewId: string | undefined,
  userUdid: string | undefined,
  hiddenMap: Record<string, string[]> | undefined,
): boolean {
  if (!viewId || !userUdid) return true;
  return !(hiddenMap?.[viewId]?.includes(userUdid) ?? false);
}
